import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./MyCourses.css";

export default function MyCourses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL || "/api"}/courses/mine`, {
          withCredentials: true,
        });
        setCourses(res.data);
      } catch (err) {
        console.error("Error fetching my courses", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  if (loading) {
    return (
      <div className="my-courses-loading">
        <div className="loader"></div>
        <p>Loading your learning dashboard...</p>
      </div>
    );
  }

  return (
    <div className="my-courses-container">
      <div className="my-courses-header">
        <h1 className="my-courses-title">📚 My Courses</h1>
        <p className="my-courses-subtitle">
          Manage your personal learning list. You have {courses.length} courses in progress.
        </p>
      </div>

      {courses.length === 0 ? (
        <div className="no-enrollments">
          <div className="no-enrollments-icon">📺</div>
          <h3>Your list is empty.</h3>
          <p>Add your favorite YouTube playlists to start learning with Focus mode!</p>
          <Link to="/add-course" className="browse-tracks-btn">Add New Course</Link>
        </div>
      ) : (
        <div className="enrollments-grid">
          {courses.map((prog) => {
            if (!prog.course) return null;
            return (
              <div key={prog._id} className="enrollment-card">
                <div className="enrollment-card-banner">
                  <img src={prog.course.thumbnail || "/default-course.jpg"} alt={prog.course.title} />
                  <div className="enrollment-category-badge">Manual Course</div>
                </div>
                <div className="enrollment-card-content">
                  <h3 className="enrollment-track-title">{prog.course.title}</h3>
                  <p className="enrollment-track-desc">by {prog.course.creatorName}</p>

                  <div className="enrollment-progress-section">
                    <div className="progress-info">
                      <span>{prog.overallPercent || 0}% Complete</span>
                    </div>
                    <div className="progress-bar-bg">
                      <div
                        className="progress-bar-fill"
                        style={{ width: `${prog.overallPercent || 0}%` }}
                      />
                    </div>
                  </div>

                  <div className="enrollment-card-footer">
                    <Link to={`/course/${prog.course._id}`} className="continue-btn">
                      {prog.courseCompleted ? "Review Course" : "Continue Learning →"}
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
